import SyslogCrud from '../../modules/ctr-r/Reporting/SyslogCrud';
import { useAuth } from '../../modules/auth';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { Routes, Route, NavLink, Navigate, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap'; // Importar Spinner para la carga

const Reporting: React.FC = () => {
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);
  const { currentUser } = useAuth();
  const [flag, setflag] = useState<number>();
  const [loading, setLoading] = useState(true); // Estado para gestionar la carga
  const navigate = useNavigate();

  // Validación de permisos y redirección con estado de carga
  useEffect(() => {
    const delay = setTimeout(() => {
      if (ListaPermisosTenant.length > 0) {
        setLoading(false); // Detener la carga cuando los permisos estén cargados
        if (!ListaPermisosTenant.includes('CTXR.Neighbor.List')) {
          // Si no tiene permisos para 'CTXR.Neighbor.List', validamos si tiene Home.Status
          if (ListaPermisosTenant.includes('Home.Status')) {
            navigate('/dashboard/status');
          } else {
            // Si no tiene Home.Status, redirigimos a cloudConnectivity
            navigate('/cloudConnectivity');
          }
        }
      }
    }, 1000); // Retraso de 1 segundo

    // Limpiar timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate]);

  // Establecer flags basados en los permisos del usuario
  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('CTXR.Neighbor.List')) {
      setflag(1);
    } else if (currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')) {
      setflag(2);
    } else if (!ListaPermisosTenant.includes('CTXR.Neighbor.List')) {
      setflag(1);
    }
  }, [currentUser, ListaPermisosTenant]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
      </div>
    );
  }

  return (
    <div className='card mb-5 mb-xl-5'>
      <ul style={{ marginLeft: '25px', marginRight: '25px' }} className="nav nav-tabs nav-line-tabs mb-5 fs-6">
        {(currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') || !ListaPermisosTenant.includes('CTXR.Neighbor.List')) && (
          <li className="nav-item">
            <NavLink
              className="nav-link active f-parrafo fs-p"
              to="syslog"
              onClick={() => setflag(1)}
            >
              Syslog
            </NavLink>
          </li>
        )}
      </ul>
      <div style={{ marginLeft: '25px', marginRight: '25px' }} className="tab-content" id="myTabContent">
        <Routes>
          {(currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') || !ListaPermisosTenant.includes('CTXR.Neighbor.List')) && (
            <Route path="syslog" element={
              <div className="tab-pane fade active show" id="kt_tab_pane_1" role="tabpanel">
                <SyslogCrud tab={flag}></SyslogCrud>
              </div>
            } />
          )}
          {/* Default route */}
          {(currentUser?.ListPermiso?.includes('CTXR.Neighbor.List') || !ListaPermisosTenant.includes('CTXR.Neighbor.List')) ? (
            <Route path="*" element={<Navigate to="syslog" />} />
          ) : (
            <Route path="*" element={<Navigate to="/accounts/billing" />} />
          )}
        </Routes>
      </div>
    </div>
  );
}

export { Reporting };
